import axios from 'axios'

export const refreshClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest', 'X-Session-Mode': 'cookie' },
})

let refreshInFlight = null
let sessionQueue = Promise.resolve()
// Serialize cookie rotation across tabs when Web Locks is available, and in this tab otherwise.
export function withSessionLock (callback) {
  if (typeof navigator !== 'undefined' && navigator.locks?.request) {
    return navigator.locks.request('campag-auth-session', callback)
  }
  const request = sessionQueue.then(callback, callback)
  sessionQueue = request.catch(() => {})
  return request
}

export function getRefreshToken () {
  if (!refreshInFlight) {
    refreshInFlight = withSessionLock(() => refreshClient.post('/refreshToken', {}))
      .finally(() => {
        refreshInFlight = null
      })
  }
  return refreshInFlight
}

export const endSession = () => withSessionLock(() => refreshClient.post('/logout', {}))
